import React, { Component } from 'react';
import {Trans, translate} from 'react-i18next';


class TermsView extends Component {
  render() {
    return (
      <div>
        <Trans i18nKey="terms_section_1">
          <p>De belangrijkste activiteit van de verkoper is de verkoop van pizza’s en andere bijgerechten, om te leveren, ter plaatse te eten of om mee te nemen.
            Deze voorwaarden zijn alleen van toepassing op niet-commerciële individuen en op het grondgebied van België.</p>
        </Trans>
        <Trans i18nKey="terms_section_2">
          <p>Deze verkoopvoorwaarden zijn van toepassing op alle productbestellingen van klanten op de website van Pizza Hut.
          De bestelling kan alleen worden geregistreerd op de website indien de Klant zich duidelijk identificeert door een klanten log-in en een paswoord aan te maken, die beiden strikt persoonlijk zijn.
            Elke bestelling impliceert de aanvaarding van prijzen en productbeschrijvingen beschikbaar bij de verkoop.</p>
        </Trans>
        <Trans i18nKey="terms_section_3">
          <p>Elke persoon die nog niet in het bezit is van een klantencode dient de inschrijvingsprocedure te volgen om zijn log-in gegevens te verkrijgen.
          In alle gevallen dient de finale validatie van de bestelling als bewijs van de volledig genoemde bestelling, op grond van de bepalingen van de wet van 13 maart 2000 op de elektronische handtekeningen en brengt als gevolg de opeisbaarheid van de bedragen verbonden aan de bestelling met zich mee.
          Deze validatie heeft dezelfde waarde als een handtekening en betekent de aanvaarding van alle transacties op de Website.
          De gegevens opgeslagen in de informaticasystemen van Pizza Hut worden veilig bewaard en worden beschouwd als bewijs van communicatie en bestellingen.
            Uitgezonderd een kennelijke fout door Pizza Hut, worden de gegevens opgeslagen in de informaticasystemen van Pizza Hut gebruikt als bewijskracht met betrekking tot bestellingen van de Klant. Het archiveren van de bestelbonnen en facturen gebeurt op een betrouwbare en duurzame manier, overeenkomstig een betrouwbare en duurzame kopie, conform het artikel 1348 van het Burgerlijk Wetboek.</p>
        </Trans>
      </div>
    );
  }
}


export default translate('translations')(TermsView);



// WEBPACK FOOTER //
// ./src/components/App/TermsView.js